import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reviewDaemonTrigger } from '../../lib/api';
import { queryKeys } from './queryKeys';

export const useTriggerReviewMutation = (token: string | null) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ triggerId, decision }: { triggerId: string; decision: 'approve' | 'reject' }) =>
      reviewDaemonTrigger(token as string, triggerId, decision),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.daemonTriggers.all,
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.me.recentRuns,
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.me.recentRunsByGroup('active'),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.me.recentRunsByGroup('past'),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.me.recentRunsByGroup('all'),
      });
    },
  });
};
